module.exports = __webpack_public_path__ + "static/img/card3.60f24723.png";